var map = {
	"./27UD88-W_icon.svg": 193,
	"./Galaxy_S9_icon.svg": 194,
	"./Huawei_P20.svg": 195,
	"./Huawei_p20_icon.svg": 196,
	"./LG_G6.svg": 197,
	"./LG_G6_icon.svg": 198,
	"./LG_G7_icon.svg": 199,
	"./LG_G7_thinQ.svg": 200,
	"./Lenovo_ThinkPad_T470p_icon.svg": 201,
	"./OnePlus_5.svg": 202,
	"./OnePlus_5_icon.svg": 203,
	"./OnePlus_6.svg": 204,
	"./OnePlus_6_icon.svg": 205,
	"./Piksl_2_XL.svg": 206,
	"./Pixel_2.svg": 207,
	"./Pixel_2_XL_icon.svg": 208,
	"./Pixel_2_icon.svg": 209,
	"./Samsung_Galaxy_Tab_S3_icon.svg": 210,
	"./Samsung_S8_S9.svg": 211,
	"./Samsung_Tab_S3.svg": 212,
	"./Surface_Pro_4.svg": 213,
	"./Surface_Pro_4_icon.svg": 214,
	"./apple_macbook12_icon.svg": 215,
	"./apple_macbook13_icon.svg": 216,
	"./apple_macbook15_icon.svg": 217,
	"./apple_thunderbolt_icon.svg": 218,
	"./eizo_EV2316W_icon.svg": 219,
	"./iPad_Air_2_icon.svg": 220,
	"./iPad_Pro_icon.svg": 221,
	"./iPad_air.svg": 222,
	"./iPad_mini.svg": 223,
	"./iPad_pro.svg": 224,
	"./iPhone_5_SE.svg": 225,
	"./iPhone_6_7_8.svg": 226,
	"./iPhone_6_7_8_icon.svg": 227,
	"./iPhone_6_7_8_plus.svg": 228,
	"./iPhone_8_Plus_icon.svg": 229,
	"./iPhone_SE_icon.svg": 230,
	"./iPhone_X.svg": 231,
	"./iPhone_X_icon.svg": 232,
	"./samsung_C49J890DKU_icon.svg": 233
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27;


//////////////////
// WEBPACK FOOTER
// ./src/assets/devices ^\.\/.*$
// module id = 27
// module chunks = 0